import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Order, PaymentType } from '@us/web/shared/data-access';
import { GetOrderParams } from '../models';

export const OrdersActions = createActionGroup({
    source: 'Orders/API',
    events: {
        'Load Orders': () => emptyProps(),
        'Load Orders Success': props<{ orders: Order[] }>(),
        'Load Orders Failure': props<{ error: string }>(),
        'Load Order': props<GetOrderParams & { onSuccess?: () => void; onFailure?: () => void }>(),
        'Load Order Success': props<{
            order: Order;
            title?: string;
            body?: string;
        }>(),
        'Load Order Failed': props<{ error: string; orderId: string }>(),
        'Load Order Payment Status': props<{ id: string }>(),
        'Complete Order': props<{ order: Order }>(),
        'Update Payment Method': props<{ orderId: string; paymentType: PaymentType, payment_detail?: any }>(),
        'Update Payment Method Success': props<{ order: Order }>(),
        'Update Payment Method Failure': props<{ error: string }>()
    }
});
